<template>
  <v-dialog
    max-width="500"
    :value="dialog"
    @input="$store.commit('orders/CLOSE_BACK_TO_CART_DIALOG')"
  >
    <v-card class="py-10 px-7">
      <CloseDialogButton
        :close="() => this.$store.commit('orders/CLOSE_BACK_TO_CART_DIALOG')"
      />
      <v-row no-gutters>
        <v-col class="font-size-lg mb-12 text-center">Go back to Cart?</v-col>
      </v-row>

      <v-row no-gutters>
        <v-col class="text-center">
          <v-btn
            class="mr-5"
            color="primary"
            height="48"
            width="180"
            rounded
            @click.stop="goBackToCart"
          >
            <div class="font-size-md text-capitalize">yes</div>
          </v-btn>
          <v-btn
            color="primary"
            height="48"
            width="180"
            rounded
            @click.stop="$store.commit('orders/CLOSE_BACK_TO_CART_DIALOG')"
          >
            <div class="font-size-md text-capitalize">no</div>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";

export default {
  name: "BackToCartDialog",
  components: { CloseDialogButton },
  computed: {
    ...mapState({
      dialog: (state) => state.orders.dialog.backToCart,
    }),
  },
  methods: {
    goBackToCart() {
      this.$store.commit("orders/CLOSE_BACK_TO_CART_DIALOG");
      this.$store.commit("cart/TOGGLE");
      this.$router.push("/");
    },
  },
};
</script>
